/**
 * Client nutrition statistics — composed from the generic read layer (no
 * dedicated endpoint): one daily timeseries of the five evening meal fields
 * and water, mapped to `UiNutritionStatistics` so the screen never sees Api
 * types. (`nutritionStats.api.ts` is the unrelated food-diary write layer.)
 */
import { MetricAggregation } from '@mfw/common';

import type { FetchNutritionStatisticsArgs } from './types/stats.types';

import {
  mapNutritionStatisticsFromApi,
  NUTRITION_DAILY_KEYS,
} from './mappers/nutritionStatistics.mappers';
import { fetchTimeseries } from './statsQuery.api';

export const fetchNutritionStatistics = async (
  args: FetchNutritionStatisticsArgs,
) => {
  const timeseries = await fetchTimeseries({
    clientId: args.clientId,
    fn: MetricAggregation.SUM,
    from: args.range.from,
    granularity: 'day',
    metricKeys: NUTRITION_DAILY_KEYS,
    to: args.range.to,
  });
  return mapNutritionStatisticsFromApi({ args, timeseries });
};
